import { render, staticRenderFns } from "./AskAI.vue?vue&type=template&id=0839543c"
import script from "./AskAI.vue?vue&type=script&lang=js"
export * from "./AskAI.vue?vue&type=script&lang=js"
import style0 from "./AskAI.vue?vue&type=style&index=0&id=0839543c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports